/** Nested blob on `activation_data` via `PATCH /api/users/:id/activation_data`. */
export const BRAND_REFRESH_ACTIVATION_DATA_KEY = 'brand_refresh_beta'

/** Help article for brand refresh early access; opens from intro modal learn-more link. */
export const BRAND_REFRESH_LEARN_MORE_HELP_URL = 'https://calendly.com/help/meet-the-new-calendly'

/** Hero column width for the intro modal (CUI horizontal Popup caps the banner at 200px). */
export const BRAND_REFRESH_INTRO_HERO_WIDTH_PX = 400

export const BRAND_REFRESH_BANNER_COUNTDOWN_DAYS = 7

/** Retries after the first countdown-expired opt-in failure (exponential backoff between tries). */
export const BRAND_REFRESH_EXPIRED_OPT_IN_MAX_RETRIES = 5

export const BRAND_REFRESH_EXPIRED_OPT_IN_BASE_DELAY_MS = 1_000

/** Debug localStorage overrides (active with `?debug=true`) — see `brandRefreshBetaDebug.ts`. */
export const BRAND_REFRESH_DEBUG_STARTED_AT_STORAGE_KEY = 'brand_refresh_beta_debug_started_at'
export const BRAND_REFRESH_DEBUG_COUNTDOWN_DAYS_STORAGE_KEY = 'brand_refresh_beta_debug_countdown_days'
export const BRAND_REFRESH_DEBUG_FORCE_EXPIRED_STORAGE_KEY = 'brand_refresh_beta_debug_force_expired'

export const BRAND_REFRESH_OPT_IN_SOURCES = {
  TRY_CONFIRM: 'try_confirm',
  COUNTDOWN_EXPIRED: 'countdown_expired',
} as const

/** Landing route after product-refresh opt-in. */
export const BRAND_REFRESH_OPT_IN_DESTINATION_PATH = '/app/scheduling/meeting_types/user/me'

/** Set before opt-in navigation; consumed by `BrandRefreshWelcomeGate`. */
export const BRAND_REFRESH_SHOW_WELCOME_SESSION_KEY = 'brand_refresh_beta_show_welcome'

/** Fired when `queueBrandRefreshWelcomeModal` runs (same-tab listeners). */
export const BRAND_REFRESH_WELCOME_QUEUED_EVENT = 'brand_refresh_beta_welcome_queued'
